<template>
  <img
    v-if="flagPath && !broken"
    :loading="lazy ? 'lazy' : 'eager'"
    :src="flagPath"
    width="25"
    height="12"
    alt=""
    @error="broken = true"
  />
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Watch,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'

const imageModules = import.meta.glob<{ default: string }>(
  '@/components/flags/images/*.svg',
  {
    query: '?url',
    eager: true,
  },
)

// Territories/dependencies that share a flag with another country
const FLAG_ALIASES: Record<string, string> = {
  BL: 'FR', // Saint Barthélemy → France
  CP: 'FR', // Clipperton Island → France
  MF: 'FR', // Saint Martin → France
  TF: 'FR', // French Southern Territories → France
  BQ: 'NL', // Bonaire → Netherlands
  BV: 'NO', // Bouvet Island → Norway
  SJ: 'NO', // Svalbard and Jan Mayen → Norway
  EA: 'ES', // Ceuta and Melilla → Spain
  HM: 'AU', // Heard and McDonald Islands → Australia
  DG: 'IO', // Diego Garcia → British Indian Ocean Territory
  UM: 'US', // US Minor Outlying Islands → United States
}

@Component
class PuFlag extends Vue {
  @Prop()
  countryIso: string

  @Prop({ default: true })
  lazy: boolean

  broken = false

  @Watch('countryIso')
  onCountryIsoChange() {
    this.broken = false
  }

  get resolvedIso() {
    return FLAG_ALIASES[this.countryIso] || this.countryIso
  }

  get flagPath() {
    if (
      !this.countryIso ||
      !/^[A-Za-z]{2}(?:-[A-Za-z]{2,10})?$/.test(this.countryIso)
    )
      return ''

    const iso = this.resolvedIso
    const viteFlag =
      imageModules[`/components/flags/images/${iso}.svg`]?.default

    // Fallback to public directory for rare flags
    return viteFlag ?? `/flags/${iso}.svg`
  }
}

export default toNative(PuFlag)
</script>

<style scoped>
img {
  width: auto;
  height: 0.75em;
  vertical-align: middle;
}
</style>
